/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit RuntimeError/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Error from './Error/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function RuntimeError({
  children,
  viewPath = "/App/RuntimeError"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Error'
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Error'}>
<Error
  viewPath={`${viewPath}/Error`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}